import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Migrate16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M1.0513 5.37316C1.02055 5.29695 1.00265 5.21418 1.00027 5.12753C0.999909 5.11433 0.999908 5.10112 1.00027 5.08792C1.00513 4.91292 1.07442 4.73929 1.20798 4.60572L3.6058 2.20791C3.88301 1.9307 4.33245 1.9307 4.60965 2.20791C4.88686 2.48511 4.88686 2.93455 4.60965 3.21176L3.42352 4.39789L11.3014 4.39789C11.6934 4.39789 12.0112 4.71569 12.0112 5.10772C12.0112 5.49975 11.6934 5.81756 11.3014 5.81756H3.42352L4.60965 7.0037C4.88686 7.2809 4.88686 7.73034 4.60965 8.00755C4.33245 8.28476 3.88301 8.28476 3.6058 8.00755L1.2079 5.60966C1.13815 5.5399 1.08594 5.45924 1.0513 5.37316ZM14.9487 10.8526C14.9794 10.7763 14.9973 10.6936 14.9997 10.6069C15.0001 10.5937 15.0001 10.5805 14.9997 10.5673C14.9949 10.3923 14.9256 10.2187 14.792 10.0851L12.3942 7.6873C12.117 7.4101 11.6675 7.4101 11.3903 7.6873C11.1131 7.96451 11.1131 8.41395 11.3903 8.69116L12.5765 9.87729L4.69856 9.87729C4.30654 9.87729 3.98873 10.1951 3.98873 10.5871C3.98873 10.9792 4.30654 11.297 4.69857 11.297H12.5765L11.3903 12.4831C11.1131 12.7603 11.1131 13.2097 11.3903 13.4869C11.6675 13.7642 12.117 13.7642 12.3942 13.4869L14.7921 11.0891C14.8618 11.0193 14.914 10.9386 14.9487 10.8526Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
